import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class CheckboxClick extends DataLayerEvent {
  validate(): boolean {
    return this.data.hasOwnProperty('clicked');
  }

  dispatch(): void {
    this.push({
      event: EventNames.CHECKBOX_CLICKED,
      ecommerce: {
        click: {
          checkbox: this.element.checked ? 'on' : 'off'
        }
      }
    });
  }
}
